<div class="panel-container w-[240px]">
  <app-create-ticket-quick-view
    #quickView
    [props]="childProps"
    (createTicket)="onCreateTicket()"
  >
  </app-create-ticket-quick-view>
</div>
